module.exports = __webpack_public_path__ + "static/hex_music@2x-e6e110eb4095367e72406affe3fa103c.png";